import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import api from 'services/api/microfwk';
import { apiCall } from 'api';
import Logger from 'services/logger';

export const useContentListPaginated = ({ url, code, orderingFetch }) => {
  const { firstNode } = useMenuRedirect();
  const [cmsCurrentNode, setCmsCurrentNode] = useState(firstNode);
  const [isLoading, setIsLoading] = useState(false);
  const [arrayOfContents, setArrayOfContents] = useState([]);
  const fetchFrom = useRef(0);
  const totalOfResults = useRef(0);
  const isFetchingRef = useRef(false);

  useEffect(
    () => {
      setCmsCurrentNode(code || firstNode);
    },
    [code],
  );

  const fetchContents = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsLoading(true);

    const params = new URLSearchParams(url.split('?')[1]);
    //Nuevos params de busqueda
    params.set('from', fetchFrom.current?.toString());
    params.set('order_id', orderingFetch?.split('-')?.[0]);
    params.set('order_way', orderingFetch?.split('-')?.[1]);

    try {
      const urlToFetch = `${url?.split('?')[0]}?${params.toString()}`;
      const { data: newContents } = await apiCall.get(urlToFetch);
      setArrayOfContents(prev => prev.concat(newContents?.response?.groups));
      const quantityFetched = Number(params.get('quantity'));
      fetchFrom.current += quantityFetched;
      totalOfResults.current = newContents?.response?.total;
    } catch (error) {
      Logger.error('[useContentListPaginated] fetch failed', {
        error: error?.message,
        stack: error?.stack,
      });
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const fetchMoreContents = async () => {
    if (isLoading || isFetchingRef.current) return;
    await fetchContents();
  };

  useEffect(
    () => {
      if (!url) return;
      //Re inicializa todo el state
      setIsLoading(true);
      setArrayOfContents([]);
      fetchFrom.current = 0;
      totalOfResults.current = 0;

      //LLAMA LA FUNCION
      fetchContents();
    },
    [url, orderingFetch],
  );

  return {
    arrayOfContents,
    fetchMoreContents,
    isLoading,
  };
};